<script setup lang="ts">
import { ChevronLeft } from '@lucide/vue'

import BaseFab from '@/components/ui/BaseFab.vue'
import { safeAreaTopOffset } from '@/services/safeAreaService'
import { Z_INDEX } from '@/utils/zIndex'

defineOptions({ name: 'MapBackButton' })

// Floating top-left "back one level" button over the map (mobile detail levels). Sized like the
// create "+" FAB (48px) but neutral white, since it's a back action, not a create action. Sits on
// the same row as the right-side sync button. Visibility is owned by the parent (v-show).
withDefaults(defineProps<{ ariaLabel?: string }>(), { ariaLabel: 'Back' })

const emit = defineEmits<{ back: [] }>()

// 12px below the notch / Dynamic Island — matches the sync button's top offset.
const topOffset = safeAreaTopOffset(12)
</script>

<template>
  <div
    class="fixed left-3"
    :style="{ top: topOffset, zIndex: Z_INDEX.POPOVER }"
    data-testid="map-back-button"
  >
    <BaseFab size="lg" variant="neutral" :aria-label="ariaLabel" @click="emit('back')">
      <ChevronLeft class="h-5.5 w-5.5" />
    </BaseFab>
  </div>
</template>
